import moment from "moment";
import { getParticipantLabel } from "Constants/constant";

const DATETIME_FORMATS = [
  "YYYY-MM-DD HH:mm:ss",
  "YYYY-MM-DD HH:mm",
  "YYYY-MM-DD",
  moment.ISO_8601,
];

/** Resolve shift date from list rows, detail payload, or schedule timestamps. */
export const resolveShiftDateForConfirm = (row) => {
  if (!row) return null;

  const dateFields = [row.shift_date, row.time_sheet_date, row.timesheet_date];
  for (const value of dateFields) {
    if (!value) continue;
    const parsed = moment(value, DATETIME_FORMATS, true);
    if (parsed.isValid()) return parsed;
    const loose = moment(value);
    if (loose.isValid()) return loose;
  }

  for (const value of [row.start_time, row.worker_start_time]) {
    if (!value) continue;
    const parsed = moment(value, DATETIME_FORMATS, true);
    if (parsed.isValid()) return parsed.startOf("day");
    const loose = moment(value);
    if (loose.isValid()) return loose.clone().startOf("day");
  }

  return null;
};

export const formatShiftDateForConfirm = (row) => {
  const parsed = resolveShiftDateForConfirm(row);
  return parsed ? parsed.format("dddd, DD/MM/YYYY") : "Date not available";
};

export const buildTimesheetConfirmDetails = (row) => {
  if (!row) return null;

  const names =
    (row.participants || [])
      .map((p) =>
        [p.first_name, p.last_name].filter(Boolean).join(" ").trim()
      )
      .filter(Boolean)
      .join(", ") || "Participant(s) not listed";

  const shiftDate = formatShiftDateForConfirm(row);

  const scheduled =
    row.start_time && row.end_time
      ? `${moment(row.start_time, DATETIME_FORMATS, true).format(
          "h:mm A"
        )} – ${moment(row.end_time, DATETIME_FORMATS, true).format("h:mm A")}`
      : "N/A";

  const actual =
    row.worker_start_time && row.worker_end_time
      ? `${moment(row.worker_start_time, DATETIME_FORMATS, true).format(
          "h:mm A"
        )} – ${moment(row.worker_end_time, DATETIME_FORMATS, true).format(
          "h:mm A"
        )}`
      : "N/A";

  return { participants: names, shiftDate, scheduled, actual };
};

export const hasScheduleActualMismatch = (row) =>
  Boolean(
    row &&
      (row.start_time !== row.worker_start_time ||
        row.end_time !== row.worker_end_time)
  );

export const TIMESHEET_CONFIRM_SUMMARY_ROWS = [
  { key: "participants", label: "Participants" },
  { key: "shiftDate", label: "Shift date" },
  { key: "scheduled", label: "Scheduled" },
  { key: "actual", label: "Actual (worker)" },
];

export const getTimesheetConfirmSummaryRows = (careSector) =>
  TIMESHEET_CONFIRM_SUMMARY_ROWS.map((row) =>
    row.key === "participants"
      ? { ...row, label: getParticipantLabel(careSector, true) }
      : row
  );
